module.exports = __webpack_public_path__ + "img/1537718658.004636c8.jpg";